import {
  topBarIdentityClasses,
  topBarIdentityNameClasses,
  topBarIdentityRoleClasses,
} from '@/shared/layout/top-bar/styles';
import type { ProfileIdentity } from '@/shared/layout/profile-panel';

/**
 * Name and role shown beside the profile button.
 *
 * Static for now — both come from the resolved session and workspace, with no
 * API of their own.
 *
 * Why it earns its space in a bar this dense: on an admin console the
 * identity question is not decoration. Operators share logins, impersonate
 * tenants, and switch between workspaces, and "which account am I acting as
 * right now" is the difference between reading the right data and acting on
 * the wrong customer's. The name answers who; the role answers how much rope
 * they have.
 *
 * Hidden below `sm`, where the bar has no room and the panel is one tap away
 * with the same information at full size.
 */
export function TopBarIdentity({ identity }: { identity: ProfileIdentity }) {
  return (
    <div className={topBarIdentityClasses}>
      <span className={topBarIdentityNameClasses} title={identity.name}>
        {identity.name}
      </span>
      <span className={topBarIdentityRoleClasses} title={identity.role}>
        {identity.role}
      </span>
    </div>
  );
}
